import Axios from 'axios'

import { getAccessToken } from '@functions/accessToken'

const urls = {
  development: 'http://localhost:7071/api',
  production: 'https://func-ch-api.azurewebsites.net/api',
  staging: 'https://func-ch-staging-api-2.azurewebsites.net/api',
  test: 'http://localhost:3000/api',
}

const clientUrls = {
  development: 'https://staging-client.contenthouse.io',
  staging: 'https://staging-client.contenthouse.io',
  production: 'https://client.contenthouse.io',
  test: 'https://staging-client.contenthouse.io',
}

export const env = process.env.REACT_APP_APPLICATION_ENV
export const baseURL = urls[process.env.REACT_APP_APPLICATION_ENV]
export const clientUrl = clientUrls[process.env.REACT_APP_APPLICATION_ENV]

const axios = Axios.create({
  baseURL: urls[process.env.REACT_APP_APPLICATION_ENV],
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

axios.interceptors.request.use(async (config) => {
  const { skipAuthentication } = config || {}

  const accessToken = skipAuthentication ? 'None' : getAccessToken()

  const updatedConfig = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  }

  return updatedConfig
},
(error) => {
  // Do something with request error
  Promise.reject(error)
})

const baseConfig = {
  method: 'get',
}

const api = (url, options = {}, config = {}) => {
  const mergedConfig = { ...baseConfig, ...config }

  return axios({
    ...mergedConfig,
    params: options,
    url,
  })
}

export default api
